var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-4",on:{"click":function($event){return _vm.scrollToElementName()}}},[_c('span',{staticClass:"bar-btn underline hover text-capitalize text-body-1 headline--text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }